module.exports = __webpack_public_path__ + "static/media/clin.0dfc147d.mp3";